<!-- Backdrop -->
<div
  class="backdrop"
  (click)="close()"></div>

<div class="time-tracking-signing-stepper">
  <mat-stepper
    #stepper
    [linear]="true"
    headerHidden="true"
    class="time-tracking-stepper">
    <mat-step-header></mat-step-header>
    <!-- Step 0: Time tracking entry and submission -->
    <mat-step
      [stepControl]="step0FormGroup"
      *ngIf="!(timeTrackingsWithFormGroup$ | async)?.[0]?.timeTracking?.toBeApprovedAt">
      <ng-template matStepLabel>{{ ("times" | i18n) || "Zeiten" }}</ng-template>
      <div class="stepper-content">
        <h3>{{ ("enterHours" | i18n) || "Stunden erfassen" }}</h3>
        <p>
          {{
            ("enterHoursDescription" | i18n) ||
              "Bitte erfasse deine Arbeitszeiten für diesen Tag."
          }}
        </p>
        <div
          *ngIf="job"
          class="job-info-header">
          <div class="job-info-header-date">
            <span class="day-of-the-week">{{ job.date | date: "EEE" }}</span>
            {{ job.date | date: "dd.MM.yyyy" }}
          </div>
          <app-job-list-item-organisation-heading
            [department]="job.department"
            [organisation]="
              job.organisation
            "></app-job-list-item-organisation-heading>
        </div>

        <div
          *ngFor="
            let timeTrackingWithFormGroup of timeTrackingsWithFormGroup$
              | async;
            let i = index;
            trackBy: trackById
          "
          class="time-tracking-entry"
          [formGroup]="timeTrackingWithFormGroup.formGroup">
          <div class="job-shifts">
            <div
              class="job-shift"
              *ngIf="job?.shifts?.[i] as shift">
              <div class="job-shift-tag">
                {{
                  shift.label
                    ? shift.label
                    : ("shifts." + timeTrackingWithFormGroup.timeTracking.shift
                      | i18n
                      | titlecase)
                }}
              </div>
              <div class="job-shift-time">
                {{ shift.from | time }} -
                {{ shift.to | time }}
              </div>
            </div>
          </div>

          <div class="time-inputs-container">
            <mat-form-field class="light-form-field">
              <mat-label>{{ ("from" | i18n) || "Von" | titlecase }}</mat-label>
              <input
                matInput
                type="time"
                formControlName="from"
                [value]="
                  timeTrackingWithFormGroup.formGroup.controls['from'].value
                "
                (ngModelChange)="updateTimeValue($event, i, 'from')"
                [attr.data-cy]="'time-tracking-from-input-step0-' + i" />
              <mat-error
                *ngIf="
                  timeTrackingWithFormGroup.formGroup.controls['from'].invalid
                ">
                {{ ("fieldRequiredError" | i18n) || "Feld ist erforderlich" }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="light-form-field">
              <mat-label>{{ ("to" | i18n) || "Bis" | titlecase }}</mat-label>
              <input
                matInput
                type="time"
                formControlName="to"
                (ngModelChange)="updateTimeValue($event, i, 'to')"
                [attr.data-cy]="'time-tracking-to-input-step0-' + i" />
              <mat-error
                *ngIf="
                  timeTrackingWithFormGroup.formGroup.controls['to'].invalid
                ">
                {{ ("fieldRequiredError" | i18n) || "Feld ist erforderlich" }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="light-form-field">
              <mat-label>{{
                ("pause" | i18n) || "Pause" | titlecase
              }}</mat-label>
              <input
                matInput
                type="text"
                inputmode="numeric"
                formControlName="pause"
                (input)="onPauseInput($event, i, 'pause')"
                (blur)="onPauseBlur($event, i, 'pause')"
                [attr.data-cy]="'time-tracking-pause-input-step0-' + i" />
            </mat-form-field>
          </div>
          <div
            class="correction-reason-container"
            *ngIf="
              displayCorrectionReason(
                timeTrackingWithFormGroup.timeTracking,
                job?.shifts?.[i]
              ) &&
              !timeTrackingWithFormGroup.formGroup.disabled
            ">
            <mat-form-field class="light-form-field correction-reason-field">
              <mat-label>{{
                ("correctionReason" | i18n) || "Grund für Korrektur"
              }}</mat-label>
              <textarea
                matInput
                [required]="
                  !!(customer$ | async)?.timeTrackingDescriptionRequiredOnChange
                "
                name="correctionReason"
                formControlName="correctionReason"
                (ngModelChange)="updateCorrectionReason($event, i)"
                [attr.data-cy]="
                  'time-tracking-correction-reason-step0-' + i
                "></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="time-tracking-total">
          {{ ("total" | i18n) || "Total" | titlecase }}:&nbsp;
          <span data-cy="time-tracking-total-display-step0">
            {{ (timeTrackingTotal$ | async) ?? 0 | time: true }}
          </span>
        </div>
        <mat-error
          *ngIf="
            step0FormGroup.get('timeTrackings')?.invalid ||
            ((timeTrackingTotal$ | async) ?? 0) < 0
          "
          class="input-error">
          <ng-container
            *ngIf="step0FormGroup.get('timeTrackings')?.errors as errors">
            {{ errors.message | i18n }}
          </ng-container>
        </mat-error>
      </div>
    </mat-step>

    <!-- Step 1: Introduction -->
    <mat-step>
      <ng-container *ngIf="!(timerExpired$ | async); else timerExpired">
        <div class="stepper-content">
          <h3>{{ ("requestSignature" | i18n) || "Unterschrift einholen" }}</h3>
          <p>
            {{
              ("requestSignatureIntro" | i18n) ||
                "Bitte begebe dich zur dienstverantwortlichen Person und übergebe ihr dein Gerät für die digitale Unterzeichnung deiner Stunden."
            }}
          </p>
          <p>
            {{
              ("requestSignatureIntroDetails" | i18n) ||
                "Falls du keine Möglichkeit hast dein Gerät physisch zu übergeben, werden deine Stunden automatisch nach Ablauf der Frist per E-Mail übermittelt."
            }}
          </p>
          <div class="countdown-timer">
            <div
              class="countdown-value"
              [class.timer-expired]="timerExpired$ | async">
              {{ getFormattedTimeRemaining() }}
            </div>
            <div class="countdown-label">
              {{ ("timeRemaining" | i18n) || "verbleibend" }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #timerExpired>
        <div class="stepper-content">
          <h2>{{ ("timerExpired" | i18n) || "Frist abgelaufen" }}</h2>
          <p>
            {{
              ("timerExpiredDescription" | i18n) ||
                "Die Frist ist abgelaufen. Deine Stunden wurden per E-Mail zur Freigabe übermittelt."
            }}
          </p>
        </div>
      </ng-template>
    </mat-step>

    <!-- Step 2: Heading only -->
    <mat-step>
      <div class="stepper-content center">
        <h2 class="big-heading">
          {{ ("handOverDevice" | i18n) || "Bitte übergebe jetzt dein Gerät" }}
        </h2>
      </div>
    </mat-step>

    <!-- Step 3: Time inputs (for review after submission) -->
    <mat-step [stepControl]="step3FormGroup">
      <ng-template matStepLabel>{{ ("times" | i18n) || "Zeiten" }}</ng-template>
      <div class="stepper-content">
        <h3>{{ ("checkHours" | i18n) || "Stunden prüfen" }}</h3>
        <p>
          {{
            "checkHoursDescription"
              | i18n
                : {
                    name:
                      invitee?.personalData?.firstName +
                      " " +
                      invitee?.personalData?.lastName
                  }
          }}
        </p>
        <div
          *ngIf="job"
          class="job-info-header">
          <div class="job-info-header-date">
            <span class="day-of-the-week">{{ job.date | date: "EEE" }}</span>
            {{ job.date | date: "dd.MM.yyyy" }}
          </div>
          <app-job-list-item-organisation-heading
            [department]="job.department"
            [organisation]="
              job.organisation
            "></app-job-list-item-organisation-heading>
        </div>

        <div
          *ngFor="
            let timeTrackingWithFormGroup of timeTrackingsWithFormGroup$
              | async;
            let i = index;
            trackBy: trackById
          "
          class="time-tracking-entry"
          [formGroup]="timeTrackingWithFormGroup.formGroup">
          <div class="job-shifts">
            <div
              class="job-shift"
              *ngIf="job?.shifts?.[i] as shift">
              <div class="job-shift-tag">
                {{
                  shift.label
                    ? shift.label
                    : ("shifts." + timeTrackingWithFormGroup.timeTracking.shift
                      | i18n
                      | titlecase)
                }}
              </div>
              <div class="job-shift-time">
                {{ shift.from | time }} -
                {{ shift.to | time }}
              </div>
            </div>
          </div>

          <div class="time-inputs-container">
            <mat-form-field class="light-form-field">
              <mat-label>{{ ("from" | i18n) || "Von" | titlecase }}</mat-label>
              <input
                matInput
                type="time"
                formControlName="from"
                [value]="
                  timeTrackingWithFormGroup.formGroup.controls['from'].value
                "
                (ngModelChange)="updateTimeValue($event, i, 'correctedFrom')"
                [attr.data-cy]="'time-tracking-from-input-' + i" />
              <mat-error
                *ngIf="
                  timeTrackingWithFormGroup.formGroup.controls['from'].invalid
                ">
                {{ ("fieldRequiredError" | i18n) || "Feld ist erforderlich" }}
              </mat-error>
              <mat-hint
                *ngIf="
                  timeTrackingWithFormGroup.timeTracking.correctedFrom !==
                    undefined &&
                  timeTrackingWithFormGroup.timeTracking.correctedFrom !=
                    timeTrackingWithFormGroup.timeTracking.from &&
                  timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
                "
                class="adjusted"
                data-cy="time-tracking-to-previous-value">
                {{ timeTrackingWithFormGroup.timeTracking.from | time }}
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="light-form-field">
              <mat-label>{{ ("to" | i18n) || "Bis" | titlecase }}</mat-label>
              <input
                matInput
                type="time"
                formControlName="to"
                (ngModelChange)="updateTimeValue($event, i, 'correctedTo')"
                [attr.data-cy]="'time-tracking-to-input-' + i" />
              <mat-error
                *ngIf="
                  timeTrackingWithFormGroup.formGroup.controls['to'].invalid
                ">
                {{ ("fieldRequiredError" | i18n) || "Feld ist erforderlich" }}
              </mat-error>
              <mat-hint
                *ngIf="
                  timeTrackingWithFormGroup.timeTracking.correctedTo !==
                    undefined &&
                  timeTrackingWithFormGroup.timeTracking.correctedTo !=
                    timeTrackingWithFormGroup.timeTracking.to &&
                  timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
                "
                class="adjusted"
                data-cy="time-tracking-to-previous-value">
                {{ timeTrackingWithFormGroup.timeTracking.to | time }}
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="light-form-field">
              <mat-label>{{
                ("pause" | i18n) || "Pause" | titlecase
              }}</mat-label>
              <input
                matInput
                type="text"
                inputmode="numeric"
                formControlName="pause"
                (input)="onPauseInput($event, i, 'correctedPause')"
                (blur)="onPauseBlur($event, i, 'correctedPause')"
                [attr.data-cy]="'time-tracking-pause-input-' + i" />
              <mat-hint
                *ngIf="
                  timeTrackingWithFormGroup.timeTracking.correctedPause !==
                    undefined &&
                  timeTrackingWithFormGroup.timeTracking.correctedPause !=
                    timeTrackingWithFormGroup.timeTracking.pause &&
                  timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
                "
                class="adjusted"
                data-cy="time-tracking-to-previous-value">
                {{ timeTrackingWithFormGroup.timeTracking.pause | time }}
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-step>

    <!-- Step 4: Signature -->
    <mat-step [stepControl]="step4FormGroup">
      <div class="stepper-content">
        <h3>
          {{ ("signHours" | i18n) || "Stunden visieren" }}
        </h3>
        <p>
          {{
            ("signHoursDescription" | i18n) ||
              "Bitte erfasse deinen Namen und bestätige die Stunden mit deiner Unterschrift."
          }}
        </p>

        <form [formGroup]="step4FormGroup">
          <mat-form-field class="light-form-field name-input">
            <mat-label>{{ ("name" | i18n) || "Name" | titlecase }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="name"
              placeholder="{{ ('name' | i18n) || 'Name' }}"
              data-cy="signature-name-input" />
            <mat-error
              *ngIf="
                step4FormGroup.get('name')?.invalid &&
                step4FormGroup.get('name')?.touched
              ">
              {{ ("fieldRequiredError" | i18n) || "Feld ist erforderlich" }}
            </mat-error>
          </mat-form-field>
        </form>

        <div class="signature-container">
          <div class="signature-wrapper">
            <canvas
              #signatureCanvas
              class="signature-canvas"
              data-cy="signature-canvas"></canvas>
            <div
              class="signature-placeholder"
              *ngIf="!(hasSignature$ | async)">
              {{ ("signHere" | i18n) || "Hier unterschreiben" }}
            </div>
          </div>

          <button
            mat-button
            type="button"
            class="clear-signature-button text-icon-button"
            (click)="clearSignature()"
            [disabled]="!(hasSignature$ | async)"
            data-cy="clear-signature-button">
            {{ ("clear" | i18n) || "Löschen" }}
          </button>

          <mat-error
            *ngIf="
              step4FormGroup.get('signature')?.invalid &&
              step4FormGroup.get('signature')?.touched
            "
            class="signature-error">
            {{
              ("signatureRequired" | i18n) || "Unterschrift ist erforderlich"
            }}
          </mat-error>
        </div>
      </div>
    </mat-step>

    <!-- Step 5: Confirmation text -->
    <mat-step>
      <div class="stepper-content">
        <h2>{{ ("timeTrackingConfirmation" | i18n) || "Vielen Dank!" }}</h2>
        <p
          [innerHTML]="
            ('timeTrackingConfirmationDescription' | i18n) ||
            'Wir haben die Stundenfreigabe erhalsten. Du kannst das Gerät nun zurückgeben.'
          "></p>
      </div>
    </mat-step>
  </mat-stepper>

  <!-- Navigation buttons -->
  <div class="stepper-navigation">
    <button
      class="outline-pill-button icon-left"
      type="button"
      *ngIf="isFirstStep() && !(timerExpired$ | async)"
      (click)="close()"
      data-cy="time-tracking-stepper-cancel">
      <mat-icon svgIcon="close"></mat-icon>
      {{ ("cancel" | i18n) || "Abbrechen" | titlecase }}
    </button>
    <button
      class="outline-pill-button icon-left"
      type="button"
      *ngIf="!isFirstStep()"
      (click)="goBack()"
      data-cy="time-tracking-stepper-back">
      <mat-icon svgIcon="chevron-left"></mat-icon>
      {{ ("back" | i18n) || "Zurück" | titlecase }}
    </button>
    <button
      class="outline-pill-button primary icon-right"
      type="button"
      *ngIf="isTimeTrackingStep() && canSubmitTimeTracking()"
      (click)="setToBeApproved($event)"
      [disabled]="!canSubmitTimeTracking()"
      data-cy="time-tracking-stepper-submit">
      <mat-icon svgIcon="clock-forward"></mat-icon>
      {{ ("submitTimeTracking" | i18n) || "Stunden abschliessen" | titlecase }}
    </button>
    <button
      class="outline-pill-button primary icon-right"
      type="button"
      *ngIf="
        !isLastStep() &&
        !isSignatureStep() &&
        !isTimeTrackingStep() &&
        !(timerExpired$ | async)
      "
      (click)="goNext()"
      [disabled]="isCurrentStepInvalid()"
      data-cy="time-tracking-stepper-continue">
      {{ ("continue" | i18n) || "Weiter" | titlecase }}
      <mat-icon svgIcon="chevron-right"></mat-icon>
    </button>
    <button
      class="outline-pill-button primary icon-right"
      type="button"
      *ngIf="isSignatureStep()"
      (click)="continueAfterSignature()"
      [disabled]="isCurrentStepInvalid()"
      data-cy="time-tracking-stepper-finish">
      {{ ("sign" | i18n) || "Visieren" | titlecase }}
      <mat-icon svgIcon="pencil-outline"></mat-icon>
    </button>
    <button
      class="outline-pill-button primary icon-right"
      type="button"
      *ngIf="isLastStep() || (isFirstStep() && (timerExpired$ | async))"
      (click)="close()"
      data-cy="time-tracking-stepper-close">
      {{ ("close" | i18n) || "Schliessen" | titlecase }}
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
</div>
